<template>
  <section class="panel pad">
    <div class="panel-head">
      <h2>公众号文案</h2>
    </div>
    <label><span>公众号名称</span><input v-model="settings.wechat_account_name" /></label>
    <label><span>二维码路径</span><input v-model="settings.wechat_qr_image" /></label>
    <label><span>登录提示</span><textarea v-model="settings.gate_hint" rows="3" /></label>
    <button type="button" class="btn primary" @click="saveSettings">保存文案</button>
    <p v-if="message" class="ok">{{ message }}</p>
  </section>
</template>

<script>
import { adminGetSettings, adminPutSettings } from '../../api/accelService'

export default {
  name: 'AdminSettings',
  data() {
    return {
      settings: {
        wechat_account_name: '',
        wechat_qr_image: '',
        gate_hint: ''
      },
      message: ''
    }
  },
  async mounted() {
    this.settings = {
      wechat_account_name: '',
      wechat_qr_image: '',
      gate_hint: '',
      ...(await adminGetSettings())
    }
  },
  methods: {
    async saveSettings() {
      this.settings = await adminPutSettings(this.settings)
      this.message = '文案已保存'
    }
  }
}
</script>
